import React from 'react';

const ModalHeader = ({ referenceNumber, marketName, categoryName, mood, onClose }) => {
	return (
		<div className="common-popup-header d-flex justify-content-between">
			<div className="popup-title d-flex align-items-center">
				<h3 className="semibold-16 mb-0">{referenceNumber}</h3>
				<span className="pl-2 gray_dark_02 regular-12">|</span>
				<ul className="list-item-with-dot ml-2">
					{marketName && <li className="regular-1 gray_dark_02">{marketName}</li>}
					{categoryName && <li className="regular-12 gray_dark_02">{categoryName}</li>}
					{mood && <li className="regular-12 gray_dark_02">{mood}</li>}
				</ul>
			</div>
			<div className="close-btn" onClick={onClose}>
				<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
			</div>
		</div>
	);
};

export default ModalHeader;
